/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysqueRadioButtonOptionsLineComponent } from './sysque-radio-button-options-line.component';
import { DxRadioGroupModule } from 'devextreme-angular';

@NgModule({
  declarations: [SysqueRadioButtonOptionsLineComponent],
  imports: [CommonModule, DxRadioGroupModule],
  exports: [SysqueRadioButtonOptionsLineComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysqueRadioButtonOptionsLineModule {}
